// extracted by mini-css-extract-plugin
export default {"container":"_2suX","header":"_17dL","headerName":"_2Znj","headerCreated":"_1TbG","headerReason":"_2oR6","item":"tXFa"};